<template>
    <UApp :locale="uiLocale">
        <UTheme :props="uiDefaults">
            <!-- The hotel has not bought the module this portal IS, so there is no screen
                 underneath that could answer. It replaces the application rather than
                 sitting inside a layout: every tab in the bar leads to the same refusal.

                 Unlike the housekeeping portal there is no exception for a device — this
                 portal has no device screen. Everything here is a person with a session,
                 and signing out is a thing that person can actually do. -->
            <ModuleNotice v-if="moduleUnlicensed" />

            <component :is="layout" v-else>
                <router-view />
            </component>
        </UTheme>
    </UApp>
</template>

<script lang="ts" setup>
    import * as locales from '@nuxt/ui/locale'
    import { computed, onMounted } from 'vue'
    import { useI18n } from 'vue-i18n'
    import { useRoute } from 'vue-router'

    import ModuleNotice from '@/components/ModuleNotice.vue'
    import Blank   from '@/layouts/Blank.vue'
    import Default from '@/layouts/Default.vue'
    import { moduleUnlicensed } from '@/libs/license'
    import { usePointerGuard } from '@/libs/pointerGuard'
    import { uiDefaults } from '@/libs/uiDefaults'

    const route = useRoute()
    const { locale } = useI18n()

    // Keeps Nuxt UI's built-in component texts in sync with the vue-i18n locale.
    const uiLocale = computed(() => (locales as Record<string, typeof locales.en>)[locale.value] ?? locales.en)

    const layouts = { Default, Blank }
    const layout  = computed(() => layouts[(route.meta.layout as keyof typeof layouts) ?? 'Default'])

    // Watches for the click lock a closed dialog can leave on the page. This portal is
    // used on a telephone, where a page that stops responding is even harder to explain
    // than at a desk — and somebody standing at a door cannot be asked to reload it.
    onMounted(usePointerGuard)
</script>
